import styled from 'styled-components'

export const Layout = styled.div`
  height: 100%;
  min-height: 100vh;
  width: 100%;
  background: ${(props) => props.theme.light};
`
